import { getAllCxAction, getAllMapsListData } from "@redux/index";
import { getFolderById } from "@redux/memoizedSelectors";
import { GroupByMap } from "features/grid-table/components/GroupByMap.js";
import DataTable from "features/grid-table/DataTable";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import DataLoader from "shared/components/data-loader";
import { PageTemplate } from "shared/global-layouts/PageTemplate";
import { GenericButton } from "shared/ui-basics/index";
import { StatusCode } from "utils/optionsSets/OptionSets";

export default function CxActions() {
	const { t } = useTranslation();
	const { search } = useLocation();
	const hideForPdf = search.hideForPdf();
	const folderId = search.getFolderId();
	const folderView = folderId === undefined ? false : true;
	const { linkedActions } = useSelector((state) => getFolderById(state, folderId), shallowEqual);
	const [key, setKey] = React.useState("list");


	useEffect(() => {
		if (folderView) {
			setKey("list");
		}
	}, [folderView]);



	const isShowViewButtons = () => {
		if (hideForPdf || folderView) return false;
		return true;
	};

	const renderViewButtons = (t) => {
		if (!isShowViewButtons()) return <></>;
		return (
			<>
				<GenericButton variant="light-link" className="ms-2" tooltip tooltipText={t("LIST_VIEW")} icon="LIST-VIEW" active={key === "list"} onClick={() => handleKeys("list")} />
				<GenericButton variant="light-link" className="ms-2" tooltip tooltipText={t("GROUP_BY_MAP")} icon="GROUP-BY" active={key === "byMap"} onClick={() => handleKeys("byMap")} />
			</>
		);
	};

	const renderView = () => {
		switch (key) {
			case "list":
				return <DataTable context="cxActions.cxActionsList" linked={linkedActions} />;
			case "byMap":
				return <GroupByMap />;
			default:
				return <></>;
		}
	};

	const handleKeys = (name) => {
		setKey(name);
	};

	return (
		<PageTemplate classNames="container-fluid p-5 pb-0" pageTitle={`${t("YOUR")} ${t("JS_80")}`} renderViewButtons={renderViewButtons}>
			<DataLoader
				asyncFns={[{ asyncFn: getAllCxAction, parameter: { statusCode: StatusCode.Active, withDetails: true } }]}
				reduxActions={[getAllMapsListData]}
				disabledSpinner={true}

			>{renderView()}</DataLoader>
		</PageTemplate>
	);
}
